import { CachedData } from "@unleashed/models/CachedData";

export class PersistentCache {

  get<T>(key: string): T | undefined {
    const text = localStorage.getItem(key);
    if (!text) {
      return undefined;
    }

    const data = JSON.parse(text) as CachedData;

    if (data && (!data.expires || Date.now() < data.expires)) {
      return data.value as T;
    }

    return undefined;
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }

  set<T>(key: string, value: T, expires?: number) {
    localStorage.setItem(key, JSON.stringify({value, expires}));
  }
}
